import { Box, Button, TableCell, TableRow, Typography } from "@mui/material";
import React, { useState } from "react";
import { ImageContainer } from "../../../../shared/components/ImageContainer";
import { EditIcon, TrashIcon } from "../../../../assets/icons/icons";
import { EditIconSvg } from "../../../../assets/icons/EditIconSvg";
import { useNavigate } from "react-router-dom";
import DeleteDialog from "../../../products/product/DeleteDialog";
import { deletePage } from "../../../../services/page";
import { toastError, toastSuccess } from "../../../../utils/ToastMessage";
import { statusType } from "../../../../utils/constants";
import {
  capitalizeFirstLetter,
  monthStringFormatDate,
} from "../../../../utils/extensions";
import CheckboxInput from "../../../../shared/components/CheckboxInput";
import PremiumIconSvg from "../../../../assets/icons/premiumComponentIcon/PremiumIconSvg";

interface tableRowProps {
  row: any;
  handleRefreshData: any;
  isSelected: any;
  onSelect: (id: any, checked: boolean) => any;
  rowsPerPage:any;
  page:any;
  search:any;
  activeFilters:any;
  status:any;
}

const handleCopyFigmaCode = (data: any) => {
  const htmlContent = data.figmaCode;
  // Create a Blob with the HTML content and specify the MIME type as 'text/html'
  const blob = new Blob([htmlContent], { type: "text/html" });
  const clipboardItem = new ClipboardItem({ "text/html": blob });
  // Copy the Blob to the clipboard
  navigator.clipboard
    .write([clipboardItem])
    .then(() => {
      // ntent copied");
    })
    .catch((err) => {
      console.error("Failed to copy: ", err);
    });
};

const Row: React.FC<tableRowProps> = ({
  row,
  handleRefreshData,
  isSelected,
  onSelect,
  rowsPerPage,
  page,
  search,
  activeFilters,
  status,
}) => {
  const navigate = useNavigate();
  const [isDeleteDialogVisible, setIsDeleteDialogVisible] = useState(false);

  const handleEdit =(row:any)=>{
    // set current state before editing
    const currentFilters = {
      search,
      page,
      rowsPerPage,
      status,
      activeFilters: activeFilters,
    };

    // Update session storage
    sessionStorage.setItem("pageFilters", JSON.stringify(currentFilters));
    
    navigate(`/page/edit/${row.id}`, {
      state: {
        data: [row],
      },
    });
  }

  const handleDelete = async () => {
    try {
      await deletePage(row?.id).then((res: any) => {
        toastSuccess("Successfully Deleted!", "Page deleted successfully.");
        handleRefreshData();
      });
    } catch (error) {
      toastError("Ops! Something went wrong.", "Failed deleting the page.");
    }
  };

  return (
    <TableRow
      onClick={() => {
        handleCopyFigmaCode(row);
      }}
      sx={{
        cursor: "pointer",
        ":hover": {
          bgcolor: "rgba(255, 255, 255, 0.06) !important",
        },
      }}
      hover
      role="checkbox"
      tabIndex={-1}
      key={row?.id}
    >
      {/* Image with title and checkbox  */}
      <TableCell
        sx={{
          // width: "fit-content",
          width: "390px",
          borderBottom: "1px solid rgba(255, 255, 255, 0.06)",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: "16px",
          }}
        >
          <CheckboxInput
            style={{ zIndex: 1 }}
            id={row.id}
            value={isSelected}
            onChange={(e, id) => {
              onSelect(row.id, e.target.checked);
            }}
          />
          {row?.thumbnailUrl && (
            <Box
              sx={{
                display: "flex",
                aspectRatio: "104/72",
                justifyContent: "center",
                alignItems: "center",
                width: "104px",
                height: "72px",
                borderRadius: "3px",
              }}
            >
              <img
                style={{
                  width: "104px",
                  height: "72px",
                  borderRadius: "3px",
                }}
                alt="cover"
                src={row?.thumbnailUrl}
              />
            </Box>
          )}
          <Box sx={{ display: "flex", gap: "6px" }}>
            <Typography
              sx={{ color: "white", fontWeight: "300" }}
              variant="body2"
            >
              {row?.title || "-"}
            </Typography>
            {row?.license == "PREMIUM" && (
              <Box sx={{ display: "flex" }}>
                <PremiumIconSvg />
              </Box>
            )}
          </Box>
        </Box>
      </TableCell>

      {/* Category  */}
      <TableCell
        sx={{
          // width: "140px",
          flex: 1,
          borderBottom: "1px solid rgba(255, 255, 255, 0.06)",
        }}
      >
        <Typography sx={{ color: "white", fontWeight: "300" }} variant="body2">
          {row?.category ? row?.category : "-"}
        </Typography>
      </TableCell>

      {/* Collection  */}
      <TableCell
        sx={{
          // width: "140px",
          flex: 1,
          borderBottom: "1px solid rgba(255, 255, 255, 0.06)",
        }}
      >
        <Typography sx={{ color: "white", fontWeight: "300" }} variant="body2">
          {row?.collectionName ? row?.collectionName : "-"}
        </Typography>
      </TableCell>

      {/* License  */}
      <TableCell
        sx={{
          // width: "140px",
          flex: 1,
          borderBottom: "1px solid rgba(255, 255, 255, 0.06)",
        }}
      >
        <Typography sx={{ color: "white", fontWeight: "300" }} variant="body2">
          {row?.license ? row?.license : "-"}
        </Typography>
      </TableCell>

      {/* Tags  */}
      {/* <TableCell
        sx={{
          width: "fit-content",
          minWidth: "153px",
          maxWidth: "153px",
          borderBottom: "1px solid rgba(255, 255, 255, 0.06)",
        }}
      >
        <Box
          sx={{ display: "flex", gap: "10px", width: "100%", flexWrap: "wrap" }}
        >
          {row?.tags?.map((tag: string, index: number) => {
            return (
              <Typography
                key={index}
                sx={{ color: "white", fontWeight: "300" }}
                variant="body2"
              >
                {capitalizeFirstLetter(tag)},
              </Typography>
            );
          })}
        </Box>
      </TableCell> */}

      {/* Status  */}
      <TableCell
        sx={{
          // width: "140px",
          flex: 1,
          borderBottom: "1px solid rgba(255, 255, 255, 0.06)",
        }}
      >
        <Typography sx={{ color: "white", fontWeight: "300" }} variant="body2">
          {row?.status ? statusType(row?.status) : "-"}
        </Typography>
      </TableCell>

      {/* Date edited  */}
      <TableCell
        sx={{
          // width: "140px",
          flex: 1,
          borderBottom: "1px solid rgba(255, 255, 255, 0.06)",
        }}
      >
        <Typography sx={{ color: "white", fontWeight: "300" }} variant="body2">
          {row?.createdAt ? monthStringFormatDate(row?.createdAt) : "-"}
        </Typography>
      </TableCell>

      {/* Action buttons  */}
      <TableCell
        sx={{
          maxWidth: "80px",
          minWidth: "80px",
          borderBottom: "1px solid rgba(255, 255, 255, 0.06)",
        }}
      >
        <Box
          sx={{
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: "20px",
          }}
        >
          <Button
            onClick={()=>{handleEdit(row)}}
            sx={{
              minWidth: "0px",
              minHeight: "0px",
              lineHeight: "0px",
              ":hover": {
                bgcolor: "none !important",
              },
            }}
          >
            <ImageContainer
              style={{ width: "24px", height: "24px" }}
              title={"edit"}
            >
              {EditIcon}
            </ImageContainer>
          </Button>

          <Button
            onClick={() => {
              setIsDeleteDialogVisible(true);
            }}
            sx={{
              minWidth: "0px",
              minHeight: "0px",
              lineHeight: "0px",
            }}
          >
            <ImageContainer
              style={{ width: "24px", height: "24px" }}
              title="trash"
            >
              {TrashIcon}
            </ImageContainer>
          </Button>
        </Box>

        {isDeleteDialogVisible && (
          <DeleteDialog
            title="Are you sure you want to delete the page ?"
            setIsDeleteDialogVisible={setIsDeleteDialogVisible}
            deleteAction={() => {
              handleDelete();
            }}
          />
        )}
      </TableCell>
    </TableRow>
  );
};

export default Row;
